import * as React from "react";
import { TableRow } from "../table/table-row/table-row.mjs";
import { TableCell } from "../table/table-cell/table-cell.mjs";
import { CategoryHeading } from "./category-heading.mjs";
import { DataCell } from "./data-cell.mjs";
import { NameRow } from "./name-row.mjs";
import { ProductComparisonTable } from "./table.mjs";
import { usePlaceholderArray, cellBEM, getItemInfoByCategoryItem } from "./utils.mjs";
const ContentTable = (props) => {
  const { category, items, isMobile } = props;
  const placeholders = usePlaceholderArray(items.length);
  const totalItemCount = items.length + placeholders.length;
  const dataCellWidth = isMobile ? 12 / totalItemCount : 2;
  return /* @__PURE__ */ React.createElement(ProductComparisonTable, { itemCount: items.length, isMobile }, /* @__PURE__ */ React.createElement("caption", null, /* @__PURE__ */ React.createElement(CategoryHeading, { label: props.label })), /* @__PURE__ */ React.createElement("thead", { className: "sr-only" }, /* @__PURE__ */ React.createElement(NameRow, { renderButton: false, items: props.items, deviceLabel: props.deviceLabel, isMobile })), /* @__PURE__ */ React.createElement("tbody", null, category.items.map((categoryItem, i) => {
    return /* @__PURE__ */ React.createElement(TableRow, { className: "product-comparison__table-row", key: i }, /* @__PURE__ */ React.createElement(TableCell, { className: cellBEM(categoryItem.isDifferent, isMobile), width: 3, type: "th", scope: "row" }, categoryItem.label, categoryItem.labelAside && /* @__PURE__ */ React.createElement(React.Fragment, null, " ", categoryItem.labelAside)), items.map((item, index) => {
      const data = getItemInfoByCategoryItem(category.id, categoryItem.id, item);
      if (data) {
        return /* @__PURE__ */ React.createElement(DataCell, { key: "".concat(data.id, "-").concat(index), categoryItem, data, isMobile, width: dataCellWidth });
      }
      return /* @__PURE__ */ React.createElement(DataCell, { key: "placeholder-".concat(index), width: dataCellWidth });
    }), placeholders.map((_i, index) => {
      return /* @__PURE__ */ React.createElement(DataCell, { key: "placeholder-".concat(index), width: dataCellWidth });
    }));
  })));
};
export {
  ContentTable
};
